import React from 'react'
import SideBar from '../Common/SideBar'
import TopBar from '../Common/TopBar'
import { useTranslation } from 'react-i18next';

export default function PrivateLayout({ children, activeSubMenu }) {
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';
  return (
    <div className="flex  h-full w-full">
      <SideBar />
      <div className={`w-[calc(100%-75px)] bg-lightgray mt-[65px] ml-[auto] side--content--area lg:pl-0 lg:pr-0 ${isRTL?"pr-16":"pl-16"}`}>
        <TopBar />
        {children}
      </div>
    </div>
  )
}
